import {
  CHECKLIST_HOUSE_PAGE_VIEWED_ANALYTICS,
  HOUSE_FINISH_BUTTON_CLICKED_ANALYTICS,
} from './types';

export const checklistHousePageViewedAnalytics = ({ photoSessionId }) => ({
  type: CHECKLIST_HOUSE_PAGE_VIEWED_ANALYTICS,
  extraProperties: {
    photoSessionId,
  },
});

export const trackChecklistHouseFinishButtonClickedAction = ({ photoSessionId, isValid }) => ({
  type: HOUSE_FINISH_BUTTON_CLICKED_ANALYTICS,
  extraProperties: {
    photoSessionId,
    isValid,
  },
});
